/**
 * Remember me preference storage with 14-day expiration.
 * Used on login to persist "Remember me" for a limited time only.
 */

const REMEMBER_ME_KEY = 'rememberMe';
const REMEMBER_ME_EXPIRES_AT_KEY = 'rememberMeExpiresAt';

/** Number of days "Remember me" stays valid. */
export const REMEMBER_ME_EXPIRY_DAYS = 14;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Returns true only if "Remember me" is set and not expired.
 * If expired, clears storage and returns false.
 */
export function getRememberMe(): boolean {
    if (typeof window === 'undefined') return false;
    const value = localStorage.getItem(REMEMBER_ME_KEY);
    const expiresAt = localStorage.getItem(REMEMBER_ME_EXPIRES_AT_KEY);
    if (value !== 'true') return false;
    const expiresAtMs = expiresAt ? Number(expiresAt) : 0;
    if (!expiresAtMs || Date.now() > expiresAtMs) {
        clearRememberMe();
        return false;
    }
    return true;
}

/**
 * Saves or clears "Remember me". When saving, sets expiration to 5 days from now.
 */
export function setRememberMe(checked: boolean): void {
    if (typeof window === 'undefined') return;
    if (checked) {
        const expiresAt = Date.now() + REMEMBER_ME_EXPIRY_DAYS * MS_PER_DAY;
        localStorage.setItem(REMEMBER_ME_KEY, 'true');
        localStorage.setItem(REMEMBER_ME_EXPIRES_AT_KEY, String(expiresAt));
    } else {
        clearRememberMe();
    }
}

/**
 * Removes "Remember me" and its expiration from storage (e.g. on logout).
 */
export function clearRememberMe(): void {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(REMEMBER_ME_KEY);
    localStorage.removeItem(REMEMBER_ME_EXPIRES_AT_KEY);
}
